import { staffBasePath } from "@oysterhr/router"

export const staffQuotePath = (search?: URLSearchParams | string) => {
  return staffBasePath({ scope: "quote", query: search && `${search}` })
}
